import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Modal } from '../common/components';
import translations from './useLocks.translations.json';
import { LockResponse } from './query/useLockQuery';
import { getUserName } from '../user';

const { addTranslations, t } = i18nNsFactory('use-locks');
addTranslations(translations);

export function checkLockOnPage(data: LockResponse | undefined, onError: any) {
  if (data?.lock && !data.owner) {
    Modal.info({
      title: t('error.title'),
      content: t(`error.object_locked`, {
        user: data?.lock ? getUserName(data.lock) : '',
      }),
      onOk: () => {
        onError();
      },
    });
  }
}
